import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { checkIfElementExists } from "../helper/dom-helper";
import 'swiper/css';

export async function initializeProductReviewImageSlider() {
    const allProductReviewSlidersQuerySelector = ".brekz-productreview-image-swiper";

    if (! await checkIfElementExists(allProductReviewSlidersQuerySelector)) {
        // We are probably on another page, just don't do anything

        return;
    }

    document.querySelectorAll(allProductReviewSlidersQuerySelector).forEach((swiperEl) => {
        new Swiper(swiperEl, {
            modules: [Navigation],
            loop: true,
            spaceBetween: 10,
            speed: 800,
            navigation: {
                nextEl: swiperEl.querySelector('.brekz-productreview-image-swiper__navigation-button[data-direction="right"] > button'),
                prevEl: swiperEl.querySelector('.brekz-productreview-image-swiper__navigation-button[data-direction="left"] > button'),
            },
            on: {
                init: (swiper) => {
                    swiper.el.classList.add('swiper-initialized');
                },
            },
        });
    });
}
